export default "__VITE_ASSET__CyMPooxj__"